import { LOCATION_FRANCE, LOCATION_USA } from '../constants/AppConstants';
import {
  SubmitApiData,
  API_POLL_SUBMIT,
  GetApiData,
  API_POLL_DATA,
  API_POLL_RESULTS,
} from '../constants/AppUrls';

export default class PollController {
  constructor() {
    // so app can know when updated
    this.onPollUpdated = new Phaser.Signal();
    this.onPollReady = new Phaser.Signal();
    this.pollResults = false;
    this.pollQuestions = false;

    // grab poll data
    GetApiData(API_POLL_DATA, this.handlePollQuestionsRecieved.bind(this));
  }

  get ready() {
    return this.pollResults != false;
  }

  /*
  ================================================================================
    GET QUESTIONS
  ================================================================================
  */

  handlePollQuestionsRecieved(response) {
    // assign the questions
    this.pollQuestions = JSON.parse(response).app.data.questions;
    //update results
    GetApiData(API_POLL_RESULTS, this.handlePollResultsRecieved.bind(this));
  }

  /*
  ================================================================================
    SUBMIT ANSWER
  ================================================================================
  */

  submitPollAnswer(locationid, answerselected) {
    // create data for api call
    const data = {
      social_type: 'none',
      entries: [
        {
          type: this.getPollLocationQuestion(locationid).id.toString(),
          searchable: answerselected.toString(),
          data: { answer: answerselected.toString() },
        },
      ],
    };
    //submit data
    SubmitApiData(data, API_POLL_SUBMIT, this.handlePollAnswerSubmitted.bind(this));
  }

  handlePollAnswerSubmitted(response) {
    //update results
    GetApiData(API_POLL_RESULTS, this.handlePollResultsRecieved.bind(this));
  }

  /*
  ================================================================================
    GET REULTS
  ================================================================================
  */

  handlePollResultsRecieved(response) {
    const data = JSON.parse(response);

    const pollResults = {};

    Object.keys(data.results).forEach((key) => {
      const locationid = this.questionIdToLocationId(key);

      pollResults[locationid] = {
        total: 0,
        answers: {},
      };

      const resultData = data.results[key];
      pollResults[locationid].total = resultData.reduce((i, r) => {
        i += parseInt(r.count);
        pollResults[locationid].answers[parseInt(r.value)] = parseInt(r.count);

        return i;
      }, 0);

      let totalPercentage = 0;

      Object.keys(pollResults[locationid].answers).forEach((key) => {
        const count = pollResults[locationid].answers[key];
        const percent = count / pollResults[locationid].total;

        pollResults[locationid].answers[key] = Math.round(percent * 100);

        totalPercentage += pollResults[locationid].answers[key];
      });

      // Does the total answers equal 100%?
      if (totalPercentage != 100) {
        // If not hack away at the first value to make up the diff
        // Wanted to do some nice dynamic logic to work it out but...
        // seemed like more hassle than it was worth
        pollResults[locationid].answers[1] =
          pollResults[locationid].answers[1] - (totalPercentage - 100);
      }
    });

    const isFirstResults = this.pollResults != null;
    this.pollResults = pollResults;
    if (isFirstResults) {
      this.onPollReady.dispatch(this.pollResults);
    }
    this.onPollUpdated.dispatch(this.pollResults);
  }

  /*
  ================================================================================
    GET POLL DATA
  ================================================================================
  */

  getPollLocationQuestion(locationid) {
    return this.pollQuestions.find((question) => {
      return question.title === locationid;
    });
  }

  getPollResults() {
    return this.pollResults;
  }

  questionIdToLocationId(questionid) {
    const question = this.pollQuestions.find((q) => {
      return q.id === questionid;
    });

    if (question) {
      return question.title;
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/PollController.js